"use strict";

var _regeneratorRuntime = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VKApiError_1 = require("./VKApiError");

var time_1 = require("./time");

var net_1 = require("./net");

var DEFAULT_REQUESTS_PER_SECOND = 3;
var TIMEOUT = 5000; // 5 seconds

var API_BASE_URL = 'https://api.vk.com/method/';
var API_VERSION = '5.92';

var BaseVKApi =
/*#__PURE__*/
function () {
  function BaseVKApi(options) {
    _classCallCheck(this, BaseVKApi);

    this.logger = options.logger;
    this.token = options.token;
    this.timeout = options.timeout || TIMEOUT;
    this.lang = options.lang;
    this.testMode = options.testMode;
    if (options.useQueue) this.queue = time_1.createQueue(options.requestsPerSecond || DEFAULT_REQUESTS_PER_SECOND);
  }

  _createClass(BaseVKApi, [{
    key: "call",
    value: function call(method, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var doRequest;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = this.filterParams(params);
                if (!params['lang'] && !!this.lang) params['lang'] = this.lang;
                if (!params['testMode'] && !!this.testMode) params['testMode'] = this.testMode;
                params['v'] = API_VERSION;
                params['access_token'] = params['access_token'] || this.token;
                if (!params['access_token']) delete params['access_token'];

                doRequest = function doRequest() {
                  return __awaiter(_this, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    var _ref, body, response, err;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return net_1.postRequest(API_BASE_URL + method, params, this.timeout);

                          case 2:
                            _ref = _context.sent;
                            body = _ref.body;
                            response = _ref.response;
                            err = _ref.err;
                            _context.next = 8;
                            return this.handleResponse(method, params, response, body, err);

                          case 8:
                            return _context.abrupt("return", _context.sent);

                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                };

                if (!this.queue) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 10;
                return this.queue.run(function () {
                  return __awaiter(_this, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2() {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            return _context2.abrupt("return", doRequest());

                          case 1:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                });

              case 10:
                return _context3.abrupt("return", _context3.sent);

              case 13:
                return _context3.abrupt("return", doRequest());

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Makes api call and if there was
     * server-side error or requests limit was reached
     * repeats the call after some timeout
     */

  }, {
    key: "callWithRetry",
    value: function callWithRetry(method, params) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.doCallWithRetry(method, params, timeout));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Stops calls queue if have one
     */

  }, {
    key: "stopQueue",
    value: function stopQueue() {
      if (this.queue) this.queue.stop();
    }
  }, {
    key: "doCallWithRetry",
    value: function doCallWithRetry(method, params) {
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
      var maxRetryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 7;
      var retryCounter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.call(method, params);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);
                retryCounter++;

                if (!(retryCounter === maxRetryCount)) {
                  _context5.next = 11;
                  break;
                }

                throw _context5.t0;

              case 11:
                if (!(_context5.t0 instanceof VKApiError_1.default)) {
                  _context5.next = 21;
                  break;
                }

                if (!(_context5.t0.errorCode == 6 || _context5.t0.errorCode == 10)) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 15;
                return time_1.delay(timeout);

              case 15:
                _context5.next = 17;
                return this.doCallWithRetry(method, params, timeout, maxRetryCount, retryCounter);

              case 17:
                return _context5.abrupt("return", _context5.sent);

              case 18:
                throw _context5.t0;

              case 21:
                _context5.next = 23;
                return time_1.delay(timeout);

              case 23:
                _context5.next = 25;
                return this.doCallWithRetry(method, params, timeout, maxRetryCount, retryCounter);

              case 25:
                return _context5.abrupt("return", _context5.sent);

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 6]]);
      }));
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(method, params, response, body, err) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!err && response.statusCode == 200 && !body.error)) {
                  _context6.next = 4;
                  break;
                }

                if (!body.execute_errors) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", body);

              case 3:
                return _context6.abrupt("return", body.response);

              case 4:
                if (!(body && body.error)) {
                  _context6.next = 7;
                  break;
                }

                if (this.logger) {
                  this.logger.warn('VK Api error\n', {
                    response: JSON.stringify(body),
                    error: VKApiError_1.default.deserialize(body.error),
                    method: method,
                    params: params
                  });
                }

                throw VKApiError_1.default.deserialize(body.error);

              case 7:
                if (!err) {
                  _context6.next = 10;
                  break;
                }

                if (this.logger) {
                  this.logger.error('VK Api:\n', {
                    'Networking error:': err,
                    method: method,
                    params: params
                  });
                }

                throw err;

              case 10:
                if (this.logger) {
                  this.logger.error('VK Api:\n', {
                    'api request error: Body:': body,
                    'Error:': err
                  });
                }

                throw err;

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "filterParams",
    value: function filterParams(params) {
      for (var paramName in params) {
        if (params[paramName] == undefined) {
          delete params[paramName];
        }
      }

      return params;
    }
  }]);

  return BaseVKApi;
}();

exports.BaseVKApi = BaseVKApi;